(function(Readmore) {
    'use strict';

    Readmore.init = function() {
        $('.js-read-more').each(function() {
            var $self = $(this);
            var $toggle = $self.find('.js-read-more-toggle');
            var $target = $self.find('.js-read-more-content');

            $toggle.on('click', function(event) {
                event.preventDefault();
                $toggle.hide();
                $target.removeClass('is-hidden');
            });
        });
    };

})(window.Way2web.Readmore = window.Way2web.Readmore || {});
